import filterQueryBuilder from 'helpers/filterToQuery'
import { requests, mainApiRoot } from './index'

export const Dashboard = {
  getFirst: filters => {
    const { startDate, endDate } = filters
    const query = filterQueryBuilder({ startDate, endDate })
    return requests.get(mainApiRoot, `/dashboard${query}`)
  },
  get: (domainId, filters) => {
    const { startDate, endDate } = filters
    const query = filterQueryBuilder({ startDate, endDate })
    return requests.get(mainApiRoot, `/dashboard/${domainId}${query}`)
  },
  websiteAudit: domainId => {
    return requests.get(mainApiRoot, `/dashboard/${domainId}/website-audits`)
  },
  seoSavings: domainId => {
    return requests.get(mainApiRoot, `/dashboard/${domainId}/seo-savings`)
  },
  seoChecklist: domainId => {
    return requests.get(mainApiRoot, `/dashboard/${domainId}/seo-checklist`)
  },
  notifications: domainId => {
    return requests.get(mainApiRoot, `/dashboard/${domainId}/notifications`)
  },
  lists: () => {
    return requests.get(mainApiRoot, '/dashboard/lists')
  },
  reports: () => {
    return requests.get(mainApiRoot, '/dashboard/reports')
  },
  keywordFinders: () => {
    return requests.get(mainApiRoot, '/dashboard/keyword-finders')
  }
}
